import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { SponsoredBanner as SponsoredBannerComponent } from '@thd-olt-component-react/sponsored-content';
import { Card } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const SponsoredBannerPropTypes = {
  id: string,
  schema: string,
};

const SponsoredBannerDefaultProps = {
  id: undefined,
  schema: undefined,
};

export function CustomRenderedSponsoredBanner({ SCROLL_BUFFER, PLACEHOLDER }) {
  function SponsoredBanner({ id, schema }) {
    return (
      <QueryProvider cacheKey={id}>
        <Hydrator
          id="sponsoredBanner-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          placeholder={PLACEHOLDER}
        >
          <Card>
            {/**
             * @TODO
             * Refactor `app.scss` to use CSS Modules.
             */}
            <div className="u-width-100 sponsored-banner">
              <SponsoredBannerComponent schema={schema} />
            </div>
          </Card>
        </Hydrator>
      </QueryProvider>
    );
  }

  SponsoredBanner.propTypes = SponsoredBannerPropTypes;
  SponsoredBanner.defaultProps = SponsoredBannerDefaultProps;

  return SponsoredBanner;
}
